export default {
  AUTOMOTIVE_ECOMMERCE: 'AUTOMOTIVE_ECOMMERCE',
  AUTOMOTIVE_RENT: 'AUTOMOTIVE_RENT',
  EXPRESS_VEHICLE_CREATION: 'EXPRESS_VEHICLE_CREATION',
  CHEDRI_COMMS_CENTER: 'CHEDRI_COMMS_CENTER',
};
